import { useQuery } from 'react-query';

import { FeaturedPartner, fetchFeaturedPartners } from '@utils/backend-api/partners';

export const FEATURED_PARTNERS_KEY = 'FEATURED_PARTNERS';

export default function usePartnersFeatured() {
  const { data: featuredPartners, isLoading: isLoadingFeaturedPartners } = useQuery<
    FeaturedPartner[]
  >(FEATURED_PARTNERS_KEY, async () => await fetchFeaturedPartners());
  return { featuredPartners, isLoadingFeaturedPartners };
}
